import { CommonModule } from '@angular/common';
import { Component, Injector, OnDestroy } from '@angular/core';
import { Meta, MetaDefinition, Title } from '@angular/platform-browser';
import { ActivatedRoute, Router, RouterModule } from '@angular/router';
import { Subscription, combineLatest } from 'rxjs';
import { LdJsonService } from 'src/_services/ld-json.service';
import { LinkDefinition, LinkService } from 'src/_services/link.service';
import { Thing, WithContext } from 'src/_utility/schema';
import { Utility } from 'utility';

@Component({
  selector: 'app-base',
  template: '',
  standalone: true,
  imports: [
    CommonModule,
    RouterModule
  ]
})
export class BaseComponent implements OnDestroy {

  private subs: Subscription[] = [];
  protected route: ActivatedRoute;
  protected router: Router;
  private title: Title;
  private meta: Meta;
  private link: LinkService;
  private LJS: LdJsonService;

  public addSubscription(...subs: Subscription[]) {
    this.subs.push(...subs);
  }


  observeParams() {
    const sub = combineLatest(
      [this.route.paramMap, this.route.queryParams],
      (paramMap, params) => ({ paramMap, params })
    );
    Utility.toPromise(sub).then();
    return sub;
  }

    /** Function called on ngOnDestroy. It will reset the seo */
    private destroySeo: (() => any) | null = null;

    /**
   * Set the seo with the value give. Modify the destroy seo to clean the seo
   * @param title Page title. The one in the tab
   * @param metaDescriptions Meta description
   * @param canonicalUrl Canonical Ulr
   * @param ldJsons ld json array
   * @param links tag link to add
   */
    setSeo(
      title: string,
      metaDescriptions: MetaDefinition[],
      canonicalUrl: string,
      ldJsons: WithContext<Thing>[],
      links: LinkDefinition[]
    ): void {
      if (this.destroySeo) {
        this.destroySeo();
      }
      const oldTitle = this.title.getTitle();
      const canonical: LinkDefinition = { rel: 'canonical', href: canonicalUrl };
      const id = 'i_' + Utility.RandomStringDateId(10);        
  
      if (title) this.title.setTitle(title);
      this.meta.addTags(metaDescriptions);
      this.link.addTag(canonical);
      links.forEach((f) => this.link.addTag(f));
  
      this.LJS.addScript(id, ldJsons);
  
      this.destroySeo = () => {
        this.title.setTitle(oldTitle);
        metaDescriptions.forEach((m) => this.meta.removeTag(`name=${m.name}`));
        [canonical, ...links].forEach((l) => this.link.removeTag(l));
        this.LJS.removeByid(id);
      };
    }

  constructor(private injector: Injector) {
    this.route = this.injector.get(ActivatedRoute);
    this.router = this.injector.get(Router);
    this.title = this.injector.get(Title);
    this.meta = this.injector.get(Meta);
    this.link = this.injector.get(LinkService);
    this.LJS = this.injector.get(LdJsonService);
  }

  ngOnDestroy(): void {
    this.subs.forEach(s => s && s.unsubscribe());
  }


}
